import { canonicalToolRendererRegistry } from '../../../components/Space/SpaceChat/renderers/canonical/CanonicalToolRendererRegistry';
import { ContactsEnrichRenderer } from './ContactsEnrichRenderer';
import { ContactsDiscoverRenderer } from './ContactsDiscoverRenderer';

export function registerContactsToolRenderers() {
  canonicalToolRendererRegistry.register('contacts_enrich', ContactsEnrichRenderer);
  canonicalToolRendererRegistry.register('contacts_discover', ContactsDiscoverRenderer);
}

registerContactsToolRenderers();
